import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FileType } from '../upload-files/upload-files.component';
import { ApiService } from '@services/api.service';
import { AlertService } from '@services/alert.service';
import {
  DocumentType,
  UPLOAD_STATUS,
} from '@public/make-payment/payment-request/payment-request-v1.component';
import { TreoAnimations } from '@treo/animations';

export type EntryKeys = {
  proofOfPayment?: string;
  nationalId?: string;
  invoice?: string;
  commission?: string;
};

@Component({
  selector: 'ew-upload-documents',
  templateUrl: './upload-documents.component.html',
  styleUrl: './upload-documents.component.scss',
  animations: TreoAnimations,
})
export class UploadDocumentsComponent {
  constructor(private API: ApiService, private ALERT: AlertService) {}

  @Input() title = '';
  @Input() subtitle = '';
  @Input() expirationDate = '';
  @Input() buttonTextUpload = '';
  @Input() infoDialog: string | null = null;
  @Input() files: DocumentType[] = [];
  @Input() acceptedTypes?: string[];
  @Input() noAuthUpload: boolean = false;
  @Input() isProofOfPayment: boolean = false;
  @Input() isIncludedInsideMatForm: boolean = false;
  @Input() required: boolean = true;
  @Input() maxSize?: number;
  @Input() uploadedDocumentsIds = {} as EntryKeys;

  @Output() documentsUploaded = new EventEmitter<EntryKeys | null>();
  @Output() valueChanged = new EventEmitter<{ file: File; key: string }>();

  filesData: FileType[] = [];
  loading = false;

  async send() {
    this.loading = true;

    for (const [index, value] of this.files.entries()) {
      const fileData = this.filesData[index];

      if (
        fileData === null &&
        this.files[index].status === UPLOAD_STATUS.Uploaded
      ) {
        this.files[index].status = UPLOAD_STATUS.Pending;
        this.uploadedDocumentsIds[value.key] = null as any;
      }

      if (!fileData || this.files[index].status === UPLOAD_STATUS.Uploaded)
        continue;

      const response = this.noAuthUpload
        ? await this.API.uploadPublicFileNoAuth(fileData.file)
        : await this.API.uploadPublicFile(fileData.file);
      this.uploadedDocumentsIds[value.key] = response.record;

      this.files[index].status = UPLOAD_STATUS.Uploaded;
      this.files[index].status = UPLOAD_STATUS.Uploaded;
    }

    this.loading = false;
    this.documentsUploaded.emit();
  }

  handleValueChanged($event: FileType, index: number) {
    this.filesData[index] = $event;

    // Emit the valueChanged event with the file and its key
    this.valueChanged.emit({ file: $event.file, key: this.files[index].key });

    this.send();

    if (this.filesData.every((fileData) => !fileData?.file)) {
      this.documentsUploaded.emit(null);
    }
  }
}
